import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetchBrandData, fetchHomePageData, fetchLeaders } from "./Slice/organisationSlice";

const Index = () => {

  const dispatch = useDispatch();
  const { brand, homePageData, leaders } = useSelector((state) => state?.organisation);

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  useEffect(() => {
    dispatch(fetchBrandData());
    dispatch(fetchHomePageData("organisations"));
    dispatch(fetchLeaders(10));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = homePageData?.title;
  });

  const leadersSilder = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },

      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const Brand = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <>
      <section className="about_content_mian">
        <Container>
          <div className="about_content">
            <h1 className="title pb-2">{homePageData?.title}</h1>
            <div
              dangerouslySetInnerHTML={prepareHtml(homePageData?.description)}
            ></div>
          </div>
        </Container>
      </section>

      <section className="leader_sec">
        <Container>
          <div className="title text-center space-bottom">
            Know Featured Leaders{" "}
          </div>
          <Slider {...leadersSilder}>
            {leaders.map((item) => (
              <div key={item.id}>
                <div className="leader_box text-center">
                  <div className="leader_img">
                    <img src={item.image} alt="career consultants for women" />
                    <div className="leader_info text-left">
                      <div>
                        <span className="name">{item.name}</span>
                        <span className="profile">{item.position}</span>
                        <span className="experience">{item.about}</span>
                      </div>
                    </div>
                  </div>
                  <span className="leader_title">{item.name}</span>
                </div>
              </div>
            ))}
          </Slider>
        </Container>
      </section>

      <section className="brand_sec">
        <Container>
          <div className="title text-center space-bottom">
            Partnering Organisations and Institutions
          </div>
          <Slider {...Brand}>
              {brand.map((item) => (
                <div key={item.id}>
                  <div className="brand">
                    <img src={item.image} alt="professional consultants for women" />
                  </div>
                </div>
              ))}
          </Slider>
        </Container>
      </section>
    </>
  );
};

export default Index;
